<template>
  <div id="enter2FAModal">
    <CModal
      :show.sync="showModal"
      size="sm"
      :centered="true"
      :closeOnBackdrop="false"
    >
      <CForm>
        <CInput
          maxlength="6"
          type="text"
          :label="label"
          placeholder="Code..."
          v-model="code"
          required
          :is-valid="validator"
        />
      </CForm>
      <template #header>
        <h5 class="modal-title">{{ title }}</h5>
        <CButtonClose @click="closeModal" />
      </template>
      <template #footer>
        <CButton
          @click="$emit('2fa-verify-code', { code })"
          color="primary"
          :disabled="!validator(code)"
          >Verify</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
      default: false,
    },
    title: {
      type: String,
      default: 'Verify 2FA',
    },
    label: {
      type: String,
      default: 'Enter 2FA code',
    },
  },
  data() {
    return {
      code: '',
    };
  },
  methods: {
    validator(val) {
      return /^\d{6}$/.test(val || '');
    },
    closeModal() {
      this.code = '';
      this.$emit('close-modal');
    },
  },
  name: 'Enter2FAModal',
};
</script>
